var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomLoansSecondary = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0F1434",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.904 36.268c4.75 0 8.58-3.835 8.58-8.58s-3.878-8.58-8.58-8.58-8.58 3.835-8.58 8.58c-.048 4.745 3.83 8.58 8.58 8.58zM31.464 32.308c4.75 0 8.58-3.835 8.58-8.58s-3.878-8.58-8.58-8.58-8.58 3.835-8.58 8.58 3.878 8.58 8.58 8.58zM12.324 45.508H7.723a1.986 1.986 0 0 0-1.999 2.003v15.794c0 1.118.883 2.003 1.999 2.003h4.601v-19.8zM73.763 42.948c-3.816-3.972-10.035-3.972-13.851 0l-6.125 6.376-2.497 2.6c-.99 1.03-2.403 1.667-3.816 1.667H35.319c-1.084 0-2.026-.883-2.073-2.011-.047-1.226.895-2.207 2.026-2.207h12.343c2.497 0 4.665-1.864 5.089-4.414.094-.589.14-1.177.14-1.815 0-1.177-.894-2.109-2.025-2.109h-6.784c-2.215 0-4.335-1.03-6.596-2.157-2.356-1.178-4.806-2.355-7.633-2.55-2.497-.197-4.994.097-7.444.833-2.59.785-4.475 3.188-4.71 5.983h-.048v20.844h35.1c2.402 0 4.664-.98 6.407-2.746l14.652-15.253c.801-.883.801-2.207 0-3.04z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomLoansSecondary);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-loans-secondary.e50e32728f9f841e5804ab7e608b0411.svg";